

























































































































import { Property } from "@/graphql/client";
import { Component, Ref, Emit, Mixins } from "vue-property-decorator";
import propertyService from "@/service/propertyService";
import typeService from "@/service/typeService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";
import MixinFormatter from "@/components/mixins/MixinFormatter.vue";
import MixinValidator from "@/components/mixins/property/MixinPropertyEditDialogValidator.vue";
import moment from "moment";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class PropertyEditDialog extends Mixins(
  MixinFormatter,
  MixinValidator
) {
  @Ref() readonly editForm!: HTMLFormElement;
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: Property = propertyService.defaultProperty;
  propertyTypes = typeService.propertyTypes;
  valid = false;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の登録日時を取得
   */
  get formattedCreatedAt(): string {
    return this.item.createdAt
      ? moment(this.item.createdAt).format("YYYY-MM-DD HH:mm:ss")
      : "";
  }
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の更新日時を取得
   */
  get formattedUpdatedAt(): string {
    return this.item.updatedAt
      ? moment(this.item.updatedAt).format("YYYY-MM-DD HH:mm:ss")
      : "";
  }

  //---------------------------
  // methods
  //---------------------------
  async fetchData(item: Property): Promise<void> {
    this.item = propertyService.defaultProperty;
    if (item.guid) {
      const prop = await propertyService.getProperty(item.guid);
      if (prop) {
        this.item = prop;
      }
    }
  }

  /**
   * ダイアログを表示します.
   */
  public async open(item: Property): Promise<void> {
    await this.fetchData(item);

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.$v.$reset();
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  save(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.isProgressing = true;
      if (this.item.guid) {
        //update
        propertyService
          .updateProperty(this.item)
          .then((result) => {
            this.isProgressing = false;
            this.notifyUpdateSuccess(result as Property);
          })
          .catch((e) => {
            console.log(e);
            this.notifyError("プロパティを登録できませんでした.");
          });
      } else {
        //create
        propertyService
          .createProperty(this.item)
          .then((result) => {
            this.isProgressing = false;
            this.notifyCreateSuccess(result as Property);
          })
          .catch((e) => {
            console.log(e);
            this.notifyError("プロパティを登録できませんでした.");
          });
      }
    }
  }

  /**
   * 登録成功
   */
  @Emit("onCreateSuccess")
  public notifyCreateSuccess(created: Property): Property {
    return created;
  }
  /**
   * 更新成功
   */
  @Emit("onUpdateSuccess")
  public notifyUpdateSuccess(updated: Property): Property {
    return updated;
  }
  /**
   * 失敗
   */
  @Emit("onError")
  public notifyError(message: string): string {
    return message;
  }
}
